import autoTable from "jspdf-autotable";
import { drawGrandTotal } from "./dwsdrawGrandTotalpdf";
import { PDF_TABLE_STYLE, PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total, isLastGroup = false) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

  const columnStyles = {
    
    0: { cellWidth: 45, halign: "left" },
    1: { cellWidth: 45, halign: "right" },
    2: { cellWidth: 45, halign: "right" },
    3: { cellWidth: 45, halign: "right" },
    4: { cellWidth: 45, halign: "right" },
    5: { cellWidth: 45, halign: "right" },


  };



  function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}


  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  // ================= HEADER =================
  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_GROUP);
  doc.rect(14, startY - 10, 270, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_GROUP);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_GROUP);
  doc.text(`${shop}`, 20, startY - 5);

  // ================= DETAIL TABLE =================
  autoTable(doc, {
    startY,
    ...PDF_TABLE_STYLE,
    head: [[
      // "Depot",
      "ALLOCATION HEAD",
      "DIRECT LABOUR",
      "DIRECT STORE",
      "ON COST LABOUR",
      "ON COST STORE",
      "Total",
      

    ]],

    body: rows.map((r) => [

      r.Allocation,
      format(r["DIRECT LABOUR"]),
      format(r["DIRECT STORE"]),
       format(r["ON COST LABOUR"]),
      format(r["ON COST STORE"]),
      format((Number(r["DIRECT LABOUR"]) + Number(r["DIRECT STORE"]) + Number(r["ON COST LABOUR"]) + Number(r["ON COST STORE"]))),




    ]),

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });

  // ================= DEPOT TOTAL =================
  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 270, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  // Depot Total text
  doc.text(`${String(shop).trim()}  Total`, 16, y + 5);


  // Credit Total
  doc.text(format(total.dl.toFixed(2)), 85, y + 5, {
    align: "right",
  });


  // Debit Total
  doc.text(format(total.ds.toFixed(2)), 150, y + 5, {
    align: "right",
  });



  doc.text(format(total.ocl.toFixed(2)), 190, y + 5, {
    align: "right",
  });

  // Credit Total
  doc.text(format(total.ocs.toFixed(2)), 240, y + 5, {
    align: "right",
  });


  // Debit Total
  doc.text(format(total.total.toFixed(2)), 280, y + 5, {
    align: "right",
  });


  // Reset text color
  doc.setTextColor(0);
  
  // Reserve space after Depot Total
  doc.lastAutoTable.finalY = y + 5;
  

  // =====================================================
// NEW PAGE ONLY IF THIS IS NOT THE LAST SHOP
// =====================================================

if (!isLastGroup) {
  doc.addPage();

  // Reset lastAutoTable position so next group starts at top
  doc.lastAutoTable.finalY = 28;
}
  //                 rectangle height ^   ^ extra space
}



